export const getSupplierOrderDisplayPrice = (order = {}) => {
  const gross = order.gross_price_before_credit_card_fee;
  if (gross !== null && gross !== undefined && gross !== '' && Number.isFinite(Number(gross)) && Number(gross) >= 0) {
    return Number(gross);
  }
  return Number(order.overridden_total_price ?? order.price ?? order.total_price ?? 0);
};

export const AREA_NAME_MAP = {
  tokyo: { zh: "东京", ja: "東京", en: "Tokyo", es: "Tokio" },
  narita_airport: { zh: "成田机场", ja: "成田空港", en: "Narita", es: "Aeropuerto de Narita" },
  haneda_airport: { zh: "羽田机场", ja: "羽田空港", en: "Haneda", es: "Aeropuerto de Haneda" },
  "haneda airport": { zh: "羽田机场", ja: "羽田空港", en: "Haneda", es: "Aeropuerto de Haneda" },
  yokohama_port: { zh: "横滨港", ja: "横浜港", en: "Yokohama", es: "Puerto de Yokohama" },
  kamakura: { zh: "镰仓", ja: "鎌倉", en: "Kamakura", es: "Kamakura" },
  chiba: { zh: "千叶", ja: "千葉", en: "Chiba", es: "Chiba" },
  hakone: { zh: "箱根", ja: "箱根", en: "Hakone", es: "Hakone" },
  mt_fuji: { zh: "富士山", ja: "富士山", en: "Mt. Fuji", es: "Monte Fuji" },
  odawara: { zh: "小田原", ja: "小田原", en: "Odawara", es: "Odawara" },
  mishima: { zh: "三岛", ja: "三島", en: "Mishima", es: "Mishima" },
  karuizawa: { zh: "轻井泽", ja: "軽井沢", en: "Karuizawa", es: "Karuizawa" },
  nikko: { zh: "日光", ja: "日光", en: "Nikko", es: "Nikko" },
  kawagoe: { zh: "川越", ja: "川越", en: "Kawagoe", es: "Kawagoe" },
  shizuoka: { zh: "静冈", ja: "静岡", en: "Shizuoka", es: "Shizuoka" },
  "Disney_land/Sea": { zh: "迪士尼乐园/海洋", ja: "ディズニーランド/シー", en: "Disneyland/DisneySea", es: "Disneyland / DisneySea" },
  kanazawa: { zh: "金泽", ja: "金沢", en: "Kanazawa", es: "Kanazawa" },
  nagoya: { zh: "名古屋", ja: "名古屋", en: "Nagoya", es: "Nagoya" },
  Takayama_Shirakawako: { zh: "高山/白川乡", ja: "高山/白川郷", en: "Takayama/Shirakawa-go", es: "Takayama / Shirakawa-go" },
  okinawa: { zh: "冲绳", ja: "沖縄", en: "Okinawa", es: "Okinawa" },
  osaka: { zh: "大阪", ja: "大阪", en: "Osaka", es: "Osaka" },
  kyoto: { zh: "京都", ja: "京都", en: "Kyoto", es: "Kioto" },
  nara: { zh: "奈良", ja: "奈良", en: "Nara", es: "Nara" },
  kobe: { zh: "神户", ja: "神戸", en: "Kobe", es: "Kobe" },
  kansai_airport: { zh: "关西机场", ja: "関西空港", en: "Kansai Airport", es: "Aeropuerto de Kansai (KIX)" },
  itami_airport: { zh: "伊丹机场", ja: "伊丹空港", en: "Itami Airport", es: "Aeropuerto de Itami (ITM)" },
  other: { zh: "其他", ja: "その他", en: "Other", es: "Otro" },
};

export const EXTRA_SERVICE_PRICES = {
  airport_sign: 2000,
  tokyo_station_sign: 3500,
  odawara_station_sign: 2500,
  hotel_sign: 0,
  shinkansen_ticket: 3000,
  hiace_14_seat_upgrade: 10000,
  fuji_5th_station: 10000,
};

export const INITIAL_EDIT_EXTRA_SERVICES = {
  airport_sign: false,
  tokyo_station_sign: false,
  odawara_station_sign: false,
  hotel_sign: false,
  shinkansen_ticket: false,
  hiace_14_seat_upgrade: false,
  fuji_5th_station: false,
  other: false,
};

export const OVERTIME_RATES = {
  alphard: 5000,
  hiace: 7000,
  premium_hiace: 10000,
};

const SUPPLIER_SQUARE_PAID_STATUSES = new Set(["paid", "completed", "complete", "approved", "success", "succeeded"]);

export const normalizeVehicle = (vehicleType) => {
  const map = { alpha: "alphard", luxury_hiace: "premium_hiace" };
  return map[vehicleType] || vehicleType || "alphard";
};

const findTerminalDetail = (text) => {
  const terminalMatch = text?.match(/(T[123]|Terminal\s*[123]|第[123]航站楼)/i);
  return terminalMatch ? terminalMatch[0] : "";
};

export const formatPickupDisplay = (order, language) => {
  if (!order) return "";

  const areaName = order.pickup_area && AREA_NAME_MAP[order.pickup_area]
    ? AREA_NAME_MAP[order.pickup_area][language] || AREA_NAME_MAP[order.pickup_area].en
    : "";
  const detail = order.pickup_location_detail || findTerminalDetail(order.pickup_location);

  if (areaName && detail) return `${areaName} ${detail}`;
  return areaName || order.pickup_location || "-";
};

export const formatDestinationDisplay = (order, language) => {
  if (!order) return "";

  const areaName = order.dropoff_area && AREA_NAME_MAP[order.dropoff_area]
    ? AREA_NAME_MAP[order.dropoff_area][language] || AREA_NAME_MAP[order.dropoff_area].en
    : "";
  const detail = order.dropoff_location_detail || findTerminalDetail(order.destination);

  if (areaName && detail) return `${areaName} ${detail}`;
  return areaName || order.destination || "-";
};

export function getTokyoDateKey(date = new Date(), offsetDays = 0) {
  const target = new Date(date);
  target.setDate(target.getDate() + offsetDays);
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Tokyo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(target);
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${values.year}-${values.month}-${values.day}`;
}

export function normalizeDateKey(value = "") {
  const match = String(value || "").trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (!match) return "";
  const [, year, month, day] = match;
  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
}

export function addDaysToDateKey(dateKey, offsetDays) {
  const normalized = normalizeDateKey(dateKey);
  if (!normalized) return "";
  const [year, month, day] = normalized.split("-").map(Number);
  const date = new Date(Date.UTC(year, month - 1, day + offsetDays));
  return [
    date.getUTCFullYear(),
    String(date.getUTCMonth() + 1).padStart(2, "0"),
    String(date.getUTCDate()).padStart(2, "0"),
  ].join("-");
}

export const isOrderIncomplete = (order) => {
  const missingFields = [];
  const placeholder = /未定|待定|待确认|未確定|to be confirmed|\btbc\b|\btbd\b|not decided/i;
  const pickup = String(order.pickup_location_detail || order.pickup_location || '').trim();
  const dropoff = String(order.dropoff_location_detail || order.destination || '').trim();
  if (!pickup || placeholder.test(pickup)) {
    missingFields.push("pickup_location");
  }
  if (!dropoff || placeholder.test(dropoff)) {
    missingFields.push("destination");
  }
  if (!order.pickup_time || order.pickup_time.trim() === "") {
    missingFields.push("pickup_time");
  }
  if (!order.customer_name || order.customer_name.trim() === "") {
    missingFields.push("customer_name");
  }
  return missingFields.length > 0 ? missingFields : null;
};

export const groupSupplierOrdersByCustomerCode = (orders) => {
  const groups = new Map();
  for (const order of orders) {
    const code = String(order.customer_code || '').trim();
    if (!groups.has(code)) groups.set(code, { code, orders: [], total: 0, missing: 0, dateFrom: '', dateTo: '' });
    const group = groups.get(code);
    group.orders.push(order);
    const date = String(order.departure_date || '');
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      if (!group.dateFrom || date < group.dateFrom) group.dateFrom = date;
      if (!group.dateTo || date > group.dateTo) group.dateTo = date;
    }
    if (order.status !== 'cancelled' && order.status !== 'deleted') group.total += getSupplierOrderDisplayPrice(order);
    if (isOrderIncomplete(order)) group.missing += 1;
  }
  return [...groups.values()];
};

export const isSupplierSquarePaid = (order) => {
  const paymentStatus = String(order?.payment_status || "").trim().toLowerCase();
  const squarePaymentStatus = String(order?.square_payment_status || "").trim().toLowerCase();
  return Boolean(
    order?.square_payment_id ||
    paymentStatus === "paid" ||
    SUPPLIER_SQUARE_PAID_STATUSES.has(squarePaymentStatus)
  );
};

export const getSupplierPaymentStatusLabel = (order, t = (key) => key) =>
  isSupplierSquarePaid(order) ? t("supplierPaymentPaid") : "";

export const normalizeSupplierSearchText = (value = "") =>
  String(value || "")
    .normalize("NFKC")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();

export const normalizeSupplierLooseKey = (value = "") =>
  normalizeSupplierSearchText(value).replace(/[\s\-‐‑‒–—―ー_・./\\()（）\[\]【】#＃:：]/g, "");

export const buildSupplierOrderSearchText = (order) => {
  if (!order) return "";
  const nestedDriver = order.assigned_driver || {};
  const nestedCustomer = order.customer || {};
  const flattened = {
    ...order,
    assigned_driver: {
      ...nestedDriver,
      vehicle_label: [nestedDriver.vehicle_brand, nestedDriver.vehicle_type, nestedDriver.plate_number].filter(Boolean).join(" "),
    },
    customer: nestedCustomer,
  };
  const rawText = normalizeSupplierSearchText(JSON.stringify(flattened));
  const looseText = [
    order.id,
    order.order_no,
    order.confirmation_code,
    order.customer_code,
    order.customer_name,
    order.phone,
    order.email,
    order.pickup_location,
    order.destination,
    order.pickup_location_detail,
    order.dropoff_location_detail,
    nestedCustomer.id,
    nestedCustomer.email,
    nestedCustomer.name,
    nestedCustomer.customer_code,
    nestedDriver.name,
    nestedDriver.phone,
  ]
    .map(normalizeSupplierLooseKey)
    .filter(Boolean)
    .join(" ");

  return `${rawText} ${looseText}`;
};

export const getSupplierCustomerCodeSearchText = (order) => {
  const nestedCustomer = order?.customer || {};
  return [
    order?.customer_code,
    nestedCustomer.customer_code,
    nestedCustomer.id,
  ]
    .map((value) => `${normalizeSupplierSearchText(value)} ${normalizeSupplierLooseKey(value)}`)
    .filter(Boolean)
    .join(" ");
};

export const getSupplierCustomerNameSearchText = (order) => {
  const nestedCustomer = order?.customer || {};
  return [
    order?.customer_name,
    nestedCustomer.name,
  ]
    .map((value) => `${normalizeSupplierSearchText(value)} ${normalizeSupplierLooseKey(value)}`)
    .filter(Boolean)
    .join(" ");
};

const matchesSupplierFilterText = (haystack, value) => {
  if (!String(value || "").trim()) return true;
  const search = normalizeSupplierSearchText(value);
  const looseSearch = normalizeSupplierLooseKey(value);
  return haystack.includes(search) || (looseSearch && haystack.includes(looseSearch));
};

export function filterSupplierOrdersByVehicle(orders = [], vehicleType = "all") {
  const normalizedFilter = normalizeVehicle(vehicleType);
  if (!vehicleType || vehicleType === "all") return [...orders];
  return orders.filter((order) => normalizeVehicle(order?.vehicle_type) === normalizedFilter);
}

export function filterSupplierOrdersByServiceType(orders = [], serviceType = "all") {
  if (!serviceType || serviceType === "all") return [...orders];
  return orders.filter((order) => String(order?.service_type || "transfer") === serviceType);
}

const csvEscape = (value) => {
  const text = value === undefined || value === null ? "" : String(value);
  return `"${text.replace(/"/g, '""')}"`;
};

export function buildSupplierOrdersCsv(orders = [], options = {}) {
  const labels = {
    orderNumber: "Order No.",
    customerName: "Customer Name",
    customerCode: "Customer Code",
    status: "Status",
    departureDate: "Departure Date",
    pickupTime: "Pickup Time",
    pickupLocation: "Pickup Location",
    destination: "Destination",
    vehicleType: "Vehicle Type",
    passengerCount: "Passengers",
    luggageCount: "Luggage",
    notes: "Notes",
    ...options.labels,
  };
  const getVehicleName = options.getVehicleName || ((type) => type || "");
  const formatPickupDisplay = options.formatPickupDisplay || ((order) => order.pickup_location_detail || order.pickup_location || order.pickup_area || "");
  const formatDestinationDisplay = options.formatDestinationDisplay || ((order) => order.dropoff_location_detail || order.destination || order.dropoff_area || "");

  const header = [
    labels.orderNumber,
    labels.customerName,
    labels.customerCode,
    labels.status,
    labels.departureDate,
    labels.pickupTime,
    labels.pickupLocation,
    labels.destination,
    labels.vehicleType,
    labels.passengerCount,
    labels.luggageCount,
    labels.notes,
  ];

  const rows = orders.map((order) => [
    order.order_no || order.confirmation_code || order.id || "",
    order.customer_name || "",
    order.customer_code || "",
    order.status || "",
    order.departure_date || "",
    order.pickup_time || "",
    formatPickupDisplay(order),
    formatDestinationDisplay(order),
    getVehicleName(order.vehicle_type),
    order.passenger_count ?? "",
    order.luggage_count ?? "",
    [order.trip_details, order.other_service_desc, order.dispatch_note, order.remarks].filter(Boolean).join(" / "),
  ]);

  return [header, ...rows].map((row) => row.map(csvEscape).join(",")).join("\n");
}

export function getOrderDateKey(order) {
  return normalizeDateKey(order?.departure_date);
}

export function getSupplierOrderTimeBucket(order, todayKey = getTokyoDateKey()) {
  const status = String(order?.status || "").toLowerCase();
  const dateKey = getOrderDateKey(order);
  const normalizedToday = normalizeDateKey(todayKey);
  const tomorrowKey = addDaysToDateKey(normalizedToday, 1);

  if (
    status === "completed" ||
    status === "已完成" ||
    status === "cancelled" ||
    status === "canceled" ||
    status === "deleted" ||
    status === "refunded" ||
    (dateKey && normalizedToday && dateKey < normalizedToday)
  ) {
    return "completed";
  }
  if (dateKey === normalizedToday) return "today";
  if (dateKey === tomorrowKey) return "tomorrow";
  return "not_started";
}

export function sortSupplierOrdersByDateTime(orders = [], sortOrder = "desc") {
  return [...orders].sort((a, b) => {
    const left = `${getOrderDateKey(a) || "9999-12-31"} ${a?.pickup_time || "99:99"}`;
    const right = `${getOrderDateKey(b) || "9999-12-31"} ${b?.pickup_time || "99:99"}`;
    const comparison = left.localeCompare(right);
    return sortOrder === "desc" ? -comparison : comparison;
  });
}

export function buildSupplierOrderSections(orders = [], sortOrder = "desc", todayKey = getTokyoDateKey()) {
  const buckets = {
    completed: [],
    today: [],
    tomorrow: [],
    not_started: [],
  };

  const sortedOrders = sortSupplierOrdersByDateTime(orders, sortOrder);
  sortedOrders.forEach((order) => {
    const bucket = getSupplierOrderTimeBucket(order, todayKey);
    buckets[bucket].push(order);
  });

  return buckets;
}

export const getFilteredAndSortedOrders = ({
  orders,
  hideCompleted,
  hideCancelled,
  orderSearchFilter = "",
  customerCodeFilter,
  customerNameFilter = "",
  departureDateFilter = "",
  departureDateToFilter = "",
  sortOrder,
  vehicleTypeFilter = "all",
  serviceTypeFilter = "all",
}) => {
  let filtered = [...orders];

  if (hideCompleted) {
    filtered = filtered.filter((order) => order.status !== "completed");
  }

  if (hideCancelled) {
    filtered = filtered.filter((order) => order.status !== "cancelled");
  }

  const normalizedDateFilter = normalizeDateKey(departureDateFilter);
  if (normalizedDateFilter) {
    const end = normalizeDateKey(departureDateToFilter);
    filtered = filtered.filter((order) => end
      ? getOrderDateKey(order) >= normalizedDateFilter && getOrderDateKey(order) <= end
      : getOrderDateKey(order) === normalizedDateFilter);
  }

  if (String(orderSearchFilter || "").trim()) {
    filtered = filtered.filter((order) => matchesSupplierFilterText(buildSupplierOrderSearchText(order), orderSearchFilter));
  }

  if (String(customerCodeFilter || "").trim()) {
    filtered = filtered.filter((order) => matchesSupplierFilterText(getSupplierCustomerCodeSearchText(order), customerCodeFilter));
  }

  if (String(customerNameFilter || "").trim()) {
    filtered = filtered.filter((order) => matchesSupplierFilterText(getSupplierCustomerNameSearchText(order), customerNameFilter));
  }

  filtered = filterSupplierOrdersByVehicle(filtered, vehicleTypeFilter);
  filtered = filterSupplierOrdersByServiceType(filtered, serviceTypeFilter);

  filtered.sort((a, b) => {
    const dateA = new Date(a.departure_date + (a.pickup_time ? ` ${a.pickup_time}` : ""));
    const dateB = new Date(b.departure_date + (b.pickup_time ? ` ${b.pickup_time}` : ""));
    return sortOrder === "desc" ? dateB - dateA : dateA - dateB;
  });

  return filtered;
};
